import apiClient from './apiClient';
import { AuthTokens } from '../../types';

const authApi = {
  register: (data: { email: string; phone: string; password: string }) =>
    apiClient.post('/auth/register', data).then((r) => r.data),

  login: (data: { email: string; password: string; deviceToken?: string }) =>
    apiClient.post('/auth/login', data).then((r) => r.data),

  verifyOtp: (data: { userId: string; otp: string; action: string; deviceToken?: string }) =>
    apiClient.post<{ data: AuthTokens }>('/auth/verify-otp', data).then((r) => r.data),

  resendOtp: (data: { userId: string; action: string }) =>
    apiClient.post('/auth/resend-otp', data).then((r) => r.data),

  logout: () => apiClient.post('/auth/logout').then((r) => r.data),

  getMe: () => apiClient.get('/auth/me').then((r) => r.data),
};

export default authApi;
